var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-window', {
    model: {
      value: _vm.stepLocal,
      callback: function callback($$v) {
        _vm.stepLocal = $$v;
      },
      expression: "stepLocal"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.ClearanceApprovalSteps.SELLER
    }
  }, [_c('repair-estimate-party-form', {
    ref: "sellerForm",
    attrs: {
      "partnerId": _vm.value.partnerId,
      "title": _vm.$t('objects.clearanceApproval.seller')
    },
    model: {
      value: _vm.value.seller,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "seller", $$v);
      },
      expression: "value.seller"
    }
  }), _c('select-entity', {
    staticClass: "mt-4",
    attrs: {
      "refType": _vm.ResourceEnum.REPORT,
      "partnerId": _vm.value.partnerId,
      "label": _vm.$t('objects.repairEstimate.reportId'),
      "hint": _vm.$t('objects.repairEstimate.reportIdHint'),
      "clearable": true
    },
    model: {
      value: _vm.value.reportId,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "reportId", $$v);
      },
      expression: "value.reportId"
    }
  })], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.ClearanceApprovalSteps.EXPIRATION
    }
  }, [_c('v-date-picker', {
    attrs: {
      "outlined": "",
      "full-width": ""
    },
    model: {
      value: _vm.value.dueFormable,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "dueFormable", $$v);
      },
      expression: "value.dueFormable"
    }
  })], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.ClearanceApprovalSteps.LINE_ITEMS
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$t('objects.clearanceApproval.title'),
      "hint": _vm.$t('objects.clearanceApproval.titleHint'),
      "persistent-hint": true,
      "outlined": "",
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.title,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "title", $$v);
      },
      expression: "value.title"
    }
  }), _c('v-autocomplete', {
    attrs: {
      "label": _vm.$t('objects.clearanceApproval.currency'),
      "clearable": "",
      "outlined": "",
      "return-object": "",
      "auto-select-first": "",
      "items": Object.values(_vm.CurrencyEnum),
      "filter": _vm.getAutocompleteFilter(function (e) {
        return [e];
      }),
      "rules": _vm.rules(_vm.RulesEnum.REQUIRED_RULE)
    },
    model: {
      value: _vm.value.currency,
      callback: function callback($$v) {
        _vm.$set(_vm.value, "currency", $$v);
      },
      expression: "value.currency"
    }
  }), _c('line-items-form', {
    attrs: {
      "showProducts": false,
      "showQuantity": false,
      "showTax": false,
      "showAdd": true,
      "showRemove": true,
      "readonly": false
    },
    model: {
      value: _vm.value,
      callback: function callback($$v) {
        _vm.value = $$v;
      },
      expression: "value"
    }
  })], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.ClearanceApprovalSteps.SEND_MAIL
    }
  }, [_vm.ClearanceApprovalSteps.SEND_MAIL === _vm.stepLocal ? _c('preselect-template-card', {
    ref: "templateCard",
    staticClass: "mt-1",
    attrs: {
      "templateKey": _vm.PreselectTemplateKeysEnum.REQUEST_CLEARANCE_APPROVAL_MAIL,
      "language": _vm.partner.language,
      "partnerId": _vm.value.partnerId,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.value.seller ? [_vm.value.seller.email] : [],
      "refs": [{
        refId: this.value.id,
        refType: _vm.ResourceEnum.CLEARANCE_APPROVAL
      }]
    }
  }) : _vm._e(), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": function click() {
        return _vm.sharedContent.copyUrl();
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemShare.btnText")) + " ")])], 1)], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.ClearanceApprovalSteps.SUCCESS
    }
  }, _vm._l(_vm.created, function (clearanceApproval) {
    return _c('refs-clearance-approval', {
      key: 'refs-clearance-approval-ref-' + clearanceApproval.id,
      attrs: {
        "item": clearanceApproval
      },
      on: {
        "click": function click($event) {
          clearanceApproval.goTo(_vm.$router).detail;
        }
      }
    });
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }